/* ==========================================================================
   Descena — ds-chat.js
   KI-Chat-Widget (Floating-Button unten LINKS + Panel). Unten rechts sitzt
   die gesetzliche Widerrufsfunktion — der Chat darf sie nie überdecken.
   Spricht mit dem Server-Proxy auf dem IONOS-Webspace; ohne erreichbaren
   Proxy fällt das Widget auf den Kontakt-Hinweis zurück.
   Kein Framework, keine Cookies — Verlauf nur im sessionStorage.
   KI-Kennzeichnung nach Art. 50 KI-VO (ab 02.08.2026): Hinweis in Kopfzeile,
   Begrüßung und Fußzeile — muss beim ersten Kontakt erkennbar bleiben.
   ========================================================================== */
(function () {
  "use strict";

  var ENDPOINT = "/apps/chat/message";  /* Shopify App Proxy -> IONOS-Backend (chat-descena/chat.php); Browser sieht nur descena.de */
  var KEY = "ds-chat-verlauf";
  var FALLBACK = "Der Chat ist gerade nicht erreichbar. Schreib uns über das Kontaktformular (Link unten) oder an info@descena.de – wir melden uns schnell.";
  var verlauf = [];
  try { verlauf = JSON.parse(sessionStorage.getItem(KEY) || "[]"); } catch (e) {}

  /* ---------- Markup ---------- */
  var fab = document.createElement("button");
  fab.type = "button";
  fab.className = "ds-chat-fab";
  fab.setAttribute("aria-label", "Fragen zur Hühnertränke? KI-Chat öffnen");
  fab.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="22" height="22"><path fill="currentColor" d="M12 3C7.03 3 3 6.58 3 11c0 2.05.87 3.92 2.3 5.33-.15 1.15-.62 2.34-1.62 3.31-.2.2-.06.55.22.53 1.9-.15 3.42-.83 4.55-1.6 1.08.4 2.28.63 3.55.63 4.97 0 9-3.58 9-8s-4.03-8-9-8Z"/></svg><span class="ds-chat-fab__label">Fragen?</span>';

  var panel = document.createElement("div");
  panel.className = "ds-chat-panel";
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-label", "Chat mit Descena");
  panel.hidden = true;
  panel.innerHTML =
    '<div class="ds-chat-kopf">' +
      '<div><strong>Descena</strong><span>KI-Assistent · antwortet automatisch</span></div>' +
      '<button type="button" class="ds-chat-zu" aria-label="Chat schließen">✕</button>' +
    '</div>' +
    '<div class="ds-chat-verlauf" aria-live="polite"></div>' +
    '<form class="ds-chat-form">' +
      '<label class="visually-hidden" for="ds-chat-eingabe">Deine Frage</label>' +
      '<input id="ds-chat-eingabe" type="text" maxlength="500" placeholder="z. B. Reicht die Tränke für 8 Hühner?" autocomplete="off">' +
      '<button type="submit" class="ds-chat-senden" aria-label="Frage senden"><svg viewBox="0 0 24 24" aria-hidden="true" width="18" height="18"><path fill="currentColor" d="M3.4 20.4 20.85 12 3.4 3.6 3.39 10l12.46 2L3.39 14z"/></svg></button>' +
    '</form>' +
    '<p class="ds-chat-fuss">KI-Assistent — kann sich irren; es gelten die Angaben auf der Produktseite. Bitte keine persönlichen Daten eingeben. <a href="/policies/privacy-policy">Datenschutz</a> · <a href="/pages/contact">Kontakt</a></p>';

  document.body.appendChild(fab);
  document.body.appendChild(panel);

  var verlaufEl = panel.querySelector(".ds-chat-verlauf");
  var eingabe = panel.querySelector("#ds-chat-eingabe");
  var form = panel.querySelector(".ds-chat-form");

  function zeile(rolle, text) {
    var el = document.createElement("div");
    el.className = "ds-chat-msg ds-chat-msg--" + rolle;
    el.textContent = text;
    verlaufEl.appendChild(el);
    verlaufEl.scrollTop = verlaufEl.scrollHeight;
    return el;
  }

  function begruessung() {
    if (!verlauf.length && !verlaufEl.childElementCount) {
      zeile("assistant", "Hallo! Ich bin ein KI-Assistent, kein Mensch. Fragen zur Hühnertränke, zu Reinigung, Winter oder Versand? Frag mich einfach — für persönliche Anliegen schreib uns über den Kontakt-Link unten.");
    }
  }

  verlauf.forEach(function (m) { zeile(m.role === "assistant" ? "assistant" : "user", m.content); });

  function offen(o) {
    panel.hidden = !o;
    fab.classList.toggle("ds-chat-fab--offen", o);
    if (o) { begruessung(); eingabe.focus(); }
  }
  fab.addEventListener("click", function () { offen(panel.hidden); });
  panel.querySelector(".ds-chat-zu").addEventListener("click", function () { offen(false); fab.focus(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) { offen(false); fab.focus(); } });

  var wartet = false;
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var frage = eingabe.value.trim();
    if (!frage || wartet) { return; }
    eingabe.value = "";
    zeile("user", frage);
    verlauf.push({ role: "user", content: frage });

    var tipp = zeile("assistant", "…");
    tipp.classList.add("ds-chat-msg--tippt");
    wartet = true;

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: verlauf.slice(-8) })
    }).then(function (r) { return r.json(); }).then(function (d) {
      tipp.classList.remove("ds-chat-msg--tippt");
      var text = (d && d.text) ? d.text : FALLBACK;
      tipp.textContent = text;
      verlauf.push({ role: "assistant", content: text });
      try { sessionStorage.setItem(KEY, JSON.stringify(verlauf.slice(-16))); } catch (err) {}
      wartet = false;
    }).catch(function () {
      tipp.classList.remove("ds-chat-msg--tippt");
      tipp.textContent = FALLBACK;
      wartet = false;
    });
  });
})();
